import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25984 22506"
    {...props}
  >
    <path
      d="m12994 7504 2237-5028L25470 297l-7002 7781-5474-574zm-2240-5027L514 304l7007 7777 5473-577-2240-5027zm-994 9481 3238 9955 3232-9957-3236-4452-3234 4454z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 367.002,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
